"use client";
import * as Dialog from "@radix-ui/react-dialog";
import classNames from "classnames";
import CloseIcon from "component/closeIcon";
import { nanoid } from "nanoid";
import { DetailedHTMLProps, InputHTMLAttributes, useState } from "react";
import { GrAdd, GrSubtract } from "react-icons/gr";
import { MdAdd, MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import styles from "./calculator.module.scss";
export function Check({
  children,
  className,
  ...props
}: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) {
  return (
    <label className={classNames(className, styles.check)}>
      <input className="sr-only" type="checkbox" {...props} />
      <MdCheckBox />
      <MdCheckBoxOutlineBlank />
      {children}
    </label>
  );
}

export function AddCustomItem({
  addToPicked,
}: {
  addToPicked: (item: PickedItem) => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger className={styles.addCustomItem} asChild>
        <button className="btn btn-white" type="button">
          <MdAdd />
          <span>Add custom item</span>
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.outercontent}>
          <div className={styles.dialogtitle}>
            <Dialog.Title>Add custom item</Dialog.Title>
            <Dialog.Close asChild>
              <button className={styles.close} aria-label="Close">
                <CloseIcon />
              </button>
            </Dialog.Close>
          </div>

          <form
            className={styles.content}
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const form = e.currentTarget;
              const formData = new FormData(form);
              addToPicked({
                id: nanoid(),
                name: formData.get("appliance") as string,
                power: Number(formData.get("power")),
                hours: Number(formData.get("hours")),
                quantity: Number(formData.get("quantity")),
              });
              form.reset();
              setOpen(false);
            }}>
            <label className={styles.label}>
              <span>Name</span>
              <input className={styles.input} required name="appliance" />
            </label>
            <label className={styles.label}>
              <span>Power (Watts)</span>
              <input className={styles.input} type="number" name="power" required min="1" step="1" />
            </label>
            <label className={styles.label}>
              <span>Hours used per day</span>
              <input className={styles.input} type="number" name="hours" required min="0.0083" step="any" max="24" />
            </label>
            <label className={styles.label}>
              <span>Quantity</span>
              <input className={styles.input} type="number" name="quantity" required min="1" step="1" />
            </label>
            <button className="btn btn-lg btn-green">Add Appliance</button>
          </form>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export function Card({
  props,
  updateHours,
  updatePower,
  removeFromList,
}: {
  props: PickedItem;
  updateHours: Updatr;
  updatePower: Updatr;
  removeFromList: () => void;
}) {
  const [hoursInput, setHoursInput] = useState(String(props.hours));

  const commitHours = (raw: string) => {
    const value = Number(raw);
    if (!raw || isNaN(value) || value < 0.0083 || value > 24) {
      setHoursInput("0.0083");
      updateHours(props.id, 0.0083);
    } else {
      updateHours(props.id, value);
    }
  };

  return (
    <li className={styles.card}>
      <div className={styles.cardHeader}>
        <h2 className={styles.cardTitle}>
          {props.name} <span className={styles.tag}>{props.quantity}</span>
        </h2>
        <button onClick={removeFromList} title="Remove" className="btn" type="button">
          <CloseIcon />
        </button>
      </div>
      <label className={styles.costumizeLabel}>
        Power
        <input
          value={props.power}
          type="number"
          required
          onChange={(e) => {
            const value = e.target.valueAsNumber;
            updatePower(props.id, isNaN(value) ? 1 : value);
          }}
          min="1"
          step="1"
          name={`${props.name}-power`}
        />{" "}
        <span aria-hidden>W</span>
      </label>
      <label className={styles.costumizeLabel}>
        Hours used per day
        <input
          required
          type="number"
          min="0.0083"
          step="any"
          max="24"
          value={hoursInput}
          onChange={(e) => setHoursInput(e.target.value)}
          onBlur={(e) => commitHours(e.target.value)}
          name={`${props.name}-hours`}
        />{" "}
        <span aria-hidden>Hrs</span>
      </label>
    </li>
  );
}

export function ItemCard({
  appliance,
  quantity,
  onQuantityChange,
}: {
  appliance: CalculatorItem;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
}) {
  return (
    <li className={styles.appcard}>
      <div>
        <div>
          <h3>{appliance.name}</h3>
          <p>Average KW: {appliance.power / 1000}</p>
        </div>
        <button
          type="button"
          onClick={() => {
            onQuantityChange(quantity ? 0 : 1);
          }}>
          {quantity ? <MdCheckBox color="var(--chateau-green)" /> : <MdCheckBoxOutlineBlank />}
        </button>
      </div>
      <div>
        <div>{!!quantity && <span className={styles.tag}>{quantity}</span>}</div>
        <div className={styles.ctrl}>
          <button
            type="button"
            onClick={() => onQuantityChange(quantity - 1)}>
            <GrSubtract />
          </button>
          <div></div>
          <button
            type="button"
            onClick={() => onQuantityChange(quantity + 1)}>
            <GrAdd />
          </button>
        </div>
      </div>
    </li>
  );
}
